import React from 'react'
import ScheduledStudiokwDetailList from './ScheduledStudiokwDetailList'
import SetTitle from '../../utils/set_title'
import Header from '../../components/Headers/Header'

export default function ScheduledStudiokwDetail() {
	SetTitle('Scheduling')
	return (
		<Header
			iconClass="fa-solid fa-chart-line fa-xl"
			title="Scheduling"
		>
			<ScheduledStudiokwDetailList />
		</Header>
	)
}